import OrganizationLocationEdit from 'src/components/Organization/pages/locations/edit';

export default OrganizationLocationEdit;
